<div class="full-height layout-column tooltip-content text-center padding-5">
  <div class="layout-row layout-align-start-center">
    <span class="br-body-1 font-weight-600">{{'Steps' | translate}}</span>
  </div>
  <div class="layout-column">
    <div *ngFor="let step of progressSteps" class="service-progress-item layout-row layout-align-start-center margin-bottom-5">
      <bringoz-icon [iconName]="(step.stepNumber <= progress.stepNumber) ? 'check-circle' : 'uncheck-circle'"
                    class="margin-top-0 margin-bottom-0 margin-right-5 padding-0"
                    [ngClass]="{'check-circle': step.stepNumber <= progress.stepNumber, 'uncheck-circle': step.stepNumber > progress.stepNumber}">

      </bringoz-icon>
      <span class="br-body-1 margin-0 padding-0" layout-align="start center">{{step.stepNumber}}
        - {{step.stepName | translate}}</span>
    </div>
  </div>
</div>
